import { useTranslation } from '@/app/i18n/client';
import AppContext from '@/components/AppContext';
import Typography from '@mui/material/Typography';
import { useContext } from 'react';

export default function PrivacyNote() {
  const app = useContext(AppContext);
  const { t } = useTranslation(app.i18n.lng, 'privacy');

  return (
    <>
      <Typography variant="h6" sx={{ mt: 4, mb: 2 }}>
        {t('privacy.note.title', 'Przetwarzanie danych osobowych')}
      </Typography>
      <ol>
        <Typography variant="body2" component="li">
          {t(
            'privacy.note.body.1',
            'Administratorem pozyskanych danych będzie spółka intelliway.pl z siedzibą w Dębicy, przy ul. Wielopolskiej 23, 39-200 Dębica świadcząca usługi utrzymania i obsługi systemu ethics.life.'
          )}
        </Typography>
        <Typography variant="body2" component="li">
          {t(
            'privacy.note.body.2',
            'Celem przetwarzania danych osobowych jest przekazanie zgłoszenia nieprawidłowości do odpowiednich komórek organizacyjnych firmy której zgłoszenie dotyczy, oraz umożliwienie zwrotnej komunikacji w sprawie zgłoszenia.'
          )}
        </Typography>
        <Typography variant="body2" component="li">
          {t(
            'privacy.note.body.3',
            'Podanie danych jest dobrowolne. W związku z tym podstawą prawną przetwarzania danych osobowych jest art. 6 ust. 1 lit. a oraz art. 9 ust. 2 lit. a RODO.'
          )}
        </Typography>
        <Typography variant="body2" component="li">
          {t(
            'privacy.note.body.4',
            'Odbiorcą danych będzie Kontrahent Administratora wybrany w zgłoszeniu jako firma której dotyczy incydent.'
          )}
        </Typography>
        <Typography variant="body2" component="li">
          {t(
            'privacy.note.body.5',
            'Osoba podająca dane ma prawo cofnięcia zgody w dowolnym momencie, bez wpływu na zgodność z prawem przetwarzania, którego dokonano na podstawie zgody przed jej cofnięciem. W przypadku cofnięcia zgody zgłoszenie zawierające dane zostanie niezwłocznie usunięte.'
          )}
        </Typography>
        <Typography variant="body2" component="li">
          {t(
            'privacy.note.body.6',
            'Dane osobowe będą przetwarzane przez okres jednego roku w celach opisanych powyżej (chyba, że obowiązujące przepisy ustanawiają inne okresy przechowywania).'
          )}
        </Typography>
        <Typography variant="body2" component="li">
          {t(
            'privacy.note.body.7',
            'Osoba podająca dane osobowe ma prawo: dostępu do treści swoich danych i otrzymania ich kopii, ich sprostowania, usunięcia lub żądania ograniczenia przetwarzania, wniesienia sprzeciwu wobec przetwarzania, a także przeniesienia danych.'
          )}
        </Typography>
        <Typography variant="body2" component="li">
          {t(
            'privacy.note.body.8',
            'Osoba podająca dane ma prawo wniesienia skargi do organu nadzorczego. Pytania w kwestiach przetwarzania podanych danych osobowych można zadawać mailowo na adres dpo@inway.pro.'
          )}
        </Typography>
      </ol>
    </>
  );
}
